module.exports = __webpack_public_path__ + "static/img/areaA_5.c85fedb.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/areaA_5.png
// module id = 1077
// module chunks = 1